import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

const selectExperiments = (state) => state?.experiments || {};
const selectExperimentsReady = (state) => state?.experiments?.loaded ?? false;
const selectFlagKey = (state, flagKey) => flagKey;
const selectExperiment = createSelector(
  [selectExperiments, selectFlagKey],
  (experiments, flagKey) => experiments[flagKey] || {}
);

const useExperiment = (flagKey) => {
  const experiment = useSelector((state) => selectExperiment(state, flagKey));
  const { enabled = false, variation_key: variationKey, variables } = experiment;
  return [enabled, variationKey, variables];
};

export {
  selectExperiments, selectExperimentsReady, selectFlagKey, selectExperiment,
};
export default useExperiment;
